module.exports = __webpack_public_path__ + "static/media/semiTractorNoTrailer_purple.684ee528.svg";